import { render } from "./CsvTable.vue?vue&type=template&id=745f315d&scoped=true"
import script from "./CsvTable.vue?vue&type=script&lang=js"
export * from "./CsvTable.vue?vue&type=script&lang=js"

import "./CsvTable.vue?vue&type=style&index=0&id=745f315d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745f315d"]])

export default __exports__